window.$ = window.jQuery = require('jquery');
require('jquery-mask-plugin'); //Newsletter, obriga todas páginas terem este pacote

require('./common/recaptchav3');
require('./common/currentLocale');
require('./common/validator');
require('./common/tabs');
require('./common/wow');
require('./components/dropdown-select-lang');

require('./utils/recaptchaV3.js');
require('./utils/modal.js');
require('./utils/modalAccept.js');

export default class App {
    constructor() {}
}

new App();
